// dev url
// export const URLKpostLogin = 'https://devapi2.kpostindia.com/v2'

// export const LocalURL = `http://192.168.0.51:2503/api/v1`

// export const LoginURL = `http://192.168.0.51:2532/api/v1`

export const NEWURL = `http://192.168.0.51:2539/api/v1`


// export const MeetingURL = `http://192.168.2.77:2503/api/v1`;

// export const MeetingURL = 'https://api.production.kmedglobal.com/api/v1'
// export const AssetsURL = `http://192.168.2.141:2523/api/v1`;
// export const LocalURL = `http://192.168.2.60:2503/api/v1`

// export const URLEMP = 'https://adminmodule.kpostindia.com'
// export const URL = 'http://192.168.0.51:2525/api/v1' // Meera Local URL

// production url
export const URLKpostLogin = 'https://devapi2.kpostindia.com/v2'
export const URLEMP = 'https://adminmodule.kpostindia.com'
export const LocalURL = 'https://api.production.kmedglobal.com/api/v1'
export const LoginURL = `https://api.admin.kmedglobal.com/api/v1`
export const AssetsURL = `https://assets-api.katbook.com/api/v1`;
export const MeetingURL = `https://api.production.kmedglobal.com/api/v1`;
